import { Tooltip } from "@/components/ui/tooltip";
import { FieldVisitListItem } from "@/pages/ata-rsa-production/field-visit/schema/field-visit.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: FieldVisitListItem;
  handleDetail: (item: FieldVisitListItem) => void;
}

export const FieldVisitActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item)}
          data-testid="field-visit-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
